module.exports = __webpack_public_path__ + "static/media/trial2.afef42b8.mp3";